import { MarkdownView } from '@chipinside/markdown'
import { Box, Typography } from '@mui/material'
import { PackageOpen } from 'lucide-react'

import { NoResultsFoundProps } from '#/components/AdvancedSearch/types'

/** Estado vazio do modal de busca, com ou sem termo digitado */
export function NoResultsFound({ subtitle, title }: NoResultsFoundProps) {
  return (
    <Box
      sx={{
        alignItems: 'center',
        color: 'grey.700',
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        gap: 1,
        justifyContent: 'center',
        textAlign: 'center',
      }}
    >
      <PackageOpen strokeWidth={1} size={80} />
      <Typography variant="h5">{title}</Typography>

      <MarkdownView style={{ color: 'currentColor', fontSize: '1.2rem' }}>{subtitle}</MarkdownView>
    </Box>
  )
}
